var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { IsBoolean, IsEnum, IsOptional, IsString } from 'class-validator';
import { TransformBoolean } from '../../../decorators';
import { Gender } from '../../../enums';
import { PartialType } from '../../../utils';
import { GetManyQueryDto } from '../../common';
export class GetManyD2CUserQueryDto extends PartialType(GetManyQueryDto) {
}
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], GetManyD2CUserQueryDto.prototype, "username", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], GetManyD2CUserQueryDto.prototype, "name", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], GetManyD2CUserQueryDto.prototype, "profileImageURL", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], GetManyD2CUserQueryDto.prototype, "phoneNumber", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], GetManyD2CUserQueryDto.prototype, "email", void 0);
__decorate([
    IsEnum(Gender),
    IsOptional(),
    __metadata("design:type", String)
], GetManyD2CUserQueryDto.prototype, "gender", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], GetManyD2CUserQueryDto.prototype, "signUpSource", void 0);
__decorate([
    TransformBoolean(),
    IsBoolean(),
    IsOptional(),
    __metadata("design:type", Boolean)
], GetManyD2CUserQueryDto.prototype, "isMarketingAgreed", void 0);
